import { ApolloClient, InMemoryCache, ApolloLink, split, gql } from '@apollo/client';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

const GRAPHQL_HTTP_URL = 'https://lk.oatos.ru/graphql';
const GRAPHQL_WS_URL = 'wss://lk.oatos.ru/graphql';

// ===== GraphQL операции =====
export const REGISTER_USER = gql`
  mutation Register(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $phone: String!
    $consent: Boolean!
    $address: AddressInput!
    $profileType: ProfileType!
    $studentProfile: StudentProfileInput
    $chairmanProfile: ChairmanProfileInput
    $villageHeadProfile: VillageHeadProfileInput
  ) {
    register(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      phone: $phone
      consent: $consent
      address: $address
      profileType: $profileType
      studentProfile: $studentProfile
      chairmanProfile: $chairmanProfile
      villageHeadProfile: $villageHeadProfile
    ) {
      success
      message
      token
      user {
        id
        firstName
        lastName
        email
        phone
      }
    }
  }
`;

export const LOGIN_USER = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      success
      message
      token
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const PING = gql`
  mutation Ping {
    ping { success message }
  }
`;

// Создание WS-линка (graphql-ws клиент)
let wsClient;
let wsLink;
function makeWsLink() {
  if (wsClient) wsClient.dispose();
  wsClient = createClient({
    url: GRAPHQL_WS_URL,
    lazy: true,           // WS открывается только при первой подписке
    retryAttempts: 0,     // без авто-retry и ре-subscribe
    connectionParams: () => {
      const token = localStorage.getItem('token');
      return token ? { authorization: `Bearer ${token}` } : {};
    },
  });
  wsLink = new GraphQLWsLink(wsClient);
}

// Инициализируем WS-линк единожды
makeWsLink();

// HTTP + auth линк
const httpLink = createUploadLink({ uri: GRAPHQL_HTTP_URL, credentials: 'include' });
const authLink = new ApolloLink((op, forward) => {
  const token = localStorage.getItem('token');
  op.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  }));
  return forward(op);
});

// split между WS и HTTP
function makeSplitLink() {
  return split(
    ({ query }) => {
      const def = getMainDefinition(query);
      return def.kind === 'OperationDefinition' && def.operation === 'subscription';
    },
    wsLink,
    authLink.concat(httpLink)
  );
}

let splitLink = makeSplitLink();

// Apollo Client
export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

// Функции регистрации и логина
export async function registerUser(input) {
  const { data } = await client.mutate({
    mutation: REGISTER_USER,
    variables: input,
  });
  return data.register;
}

export async function loginUser(email, password) {
  const { data } = await client.mutate({
    mutation: LOGIN_USER,
    variables: { email, password },
  });
  if (data.login.success && data.login.token) {
    localStorage.setItem('token', data.login.token);
    // WS соединение подтянет новый токен при следующем подключении (lazy mode)
  }
  return data.login;
}
